import {
  default as ReactSignatureCanvas,
  default as SignatureCanvas,
} from "react-signature-canvas";
import Back from "../../../../svg/Back";
import { ButtonClear, Section, SignatureCanvasWrapper } from "./styled";

interface ToDesignProps {
  signatureRef: React.RefObject<SignatureCanvas>;
  initialRef: React.RefObject<SignatureCanvas>;
  errorInitialDesign: boolean;
  errorSignatureDesign: boolean;
}
const ToDesign = ({
  signatureRef,
  initialRef,
  errorInitialDesign,
  errorSignatureDesign,
}: ToDesignProps) => {
  return (
    <Section>
      <SignatureCanvasWrapper>
        <p style={{ color: "#474747", fontSize: "12px" }}>
          Desenhar Assinatura
        </p>
        <SignatureCanvas
          ref={signatureRef}
          canvasProps={{
            className: "signature-canvas",
            style: {
              border: "2px dashed #474747",
              cursor: "crosshair",
              borderRadius: "14px",
            },
          }}
        />
        {errorSignatureDesign && (
          <p
            style={{
              position: "absolute",
              bottom: "-14px",
              left: "8px",
              fontSize: "12px",
              color: "red",
            }}
          >
            Por favor, desenhe sua rubrica
          </p>
        )}
      </SignatureCanvasWrapper>
      <ButtonClear onClick={() => signatureRef.current?.clear()}>
        <Back /> Limpar
      </ButtonClear>
      <SignatureCanvasWrapper>
        <p style={{ color: "#474747", fontSize: "12px" }}>Desenhar Rubrica</p>
        <ReactSignatureCanvas
          ref={initialRef}
          canvasProps={{
            height: 160,
            className: "initial-canvas",
            style: {
              border: "2px dashed #474747",
              cursor: "crosshair",
              borderRadius: "14px",
            },
          }}
        />
        {errorInitialDesign && (
          <p
            style={{
              position: "absolute",
              bottom: "-14px",
              left: "8px",
              fontSize: "12px",
              color: "red",
            }}
          >
            Por favor, desenhe sua rubrica
          </p>
        )}
      </SignatureCanvasWrapper>
      <ButtonClear onClick={() => initialRef.current?.clear()}>
        <Back /> Limpar
      </ButtonClear>
    </Section>
  );
};

export default ToDesign;
